var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manage-related-events-container margin-side" },
    [
      _c("div", { staticClass: "btn-back-wrapper" }, [
        _c("div", {
          staticClass: "btn-back icon-back",
          on: { click: _vm.btnBackClick }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-title h2-text" }, [
        _vm._v("Manage Events")
      ]),
      _vm._v(" "),
      _vm.eventId !== -1
        ? _c("ManageRelatedEvents", {
            attrs: {
              relatedEvents: _vm.relatedEvents,
              currentEvent: _vm.currentEvent,
              eventId: _vm.eventId
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-596bc18c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596bc18c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/event/ManageRelatedEvents.vue
// module id = 1831
// module chunks = 1